import { FieldType } from '@/components/table/_fieldDefinitions/FieldType.ts';
import { SingleFilterForm } from '@/components/table/schemas/filterCriteriaSchema.ts';
import timeUtils from '@/utils/timeUtils.ts';

/**
 * Wartości filtrów DATE/DATE_TIME idą na drut bez strefy — backend osadza je
 * w strefie czasowej firmy. Bez tej serializacji JSON.stringify(Date) wysłałby
 * ISO w UTC (z "Z"), przesuwając granicę filtra o offset strefy.
 */
const serializeDateValue = <T>(value: T): T | string =>
  value instanceof Date ? timeUtils.toJavaLocalDateTime(value) : value;

export const serializeFilters = (
  filters: SingleFilterForm[],
): SingleFilterForm[] =>
  filters.map((filter) => {
    if (filter.type !== FieldType.DATE && filter.type !== FieldType.DATE_TIME) {
      return filter;
    }
    // Unia filtrów nie dyskryminuje po `type` (FieldType zamiast literału),
    // stąd jawne zawężenie kształtu filtra datowego.
    const dateFilter = filter as SingleFilterForm & {
      value: Date | string;
      secondValue?: Date | string;
    };
    return {
      ...dateFilter,
      value: serializeDateValue(dateFilter.value),
      secondValue: serializeDateValue(dateFilter.secondValue),
    } as SingleFilterForm;
  });
